import React, { PureComponent } from 'react';
import Distance from './Distance.js';
import injectSheet from 'react-jss';
import { Scrollama, Step } from 'react-scrollama';

const styles = {
  description: {
    margin: '10px auto 30px',
    fontSize: 22,
    lineHeight: '28px',
    '& a': {
      color: 'black',
    },
  },
  graphicContainer: {
    padding: '20vh 0vw 20vh',
    display: 'flex',
    justifyContent: 'space-between',
  },
  graphic: {
    flexBasis: '60%',
    position: 'sticky',
    width: '100%',
    height: '60vh',
    top: '20vh',
    // backgroundColor: '#aaa',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    '& p': {
      fontSize: '5rem',
      fontWeight: 700,
      textAlign: 'center',
      color: '#fff',
    },
  },
  scroller: {
    flexBasis: '38%',
    paddingRight: '2rem'
  }
}

class Tozama extends PureComponent {
  state = {
    data: 0,
    progress: 0,
    steps: [
      {
        description: "先ほど「江戸から遠い場所には外様大名が多い」と紹介しました。しかし、実は譜代大名にも、江戸からはるか彼方に配置されている大名がいるのです。"
      },
      {
        description: "譜代大名の多くは、江戸から0〜400km程度の場所に配置されています（江戸・大坂の距離が約400km）。その一方で、800kmあたりにいくつかの円がプロットされていますね。"
      },
      {
        description: "そこで、これらの譜代大名が領国に配置された時期を見てみることにしましょう。"
      },
    ],
  }
  onStepEnter = e => {
    const { data, entry, direction } = e;
    this.setState({ data });
  }
  onStepProgress = ({ progress }) => {
    // console.log(progress)
    this.setState({ progress });
  };
  onStepExit = ({ direction, data }) => {
    if (direction === 'up' && data === this.state.steps[0]) {
      this.setState({ data: 0 });
    }
  }
  render() {
    const { data, steps, progress, zoomLevel, initialCenterPos } = this.state;
    const { classes } = this.props;

    return (
      <>
        <div className={classes.graphicContainer}>
          <div className={classes.graphic}>
            <Distance class="w-full" />
          </div>
          <div className={classes.scroller}>
            <Scrollama
              onStepEnter={this.onStepEnter}
              onStepExit={this.onStepExit}
              progress
              onStepProgress={this.onStepProgress}
              offset="400px"
            // debug
            >
              {steps.map(el => {
                const isVisible = el.value === data;
                const visibility = isVisible ? 'visible' : 'hidden';
                return (
                  <Step data={el.value} key={el.value}>
                    <div class="step-wrapper">
                      <div class="box" className={classes.step}>
                        {el.title && <p class="title">{el.title}</p>}
                        <p>{el.description}</p>
                      </div>
                    </div>
                  </Step>
                );
              })}
            </Scrollama>
          </div>
        </div>
      </>
    )
  }
}

export default injectSheet(styles)(Tozama);
